import { AlertTriangle } from 'lucide-react'
import { TokenBudgetIcon } from './TokenBudgetIcon'
import { formatUsd } from '@/lib/currencyFormatters'

interface ContextBudgetExhaustedBannerProps {
  message: string
  currentSpendUsd?: number | null
  capUsd?: number | null
}

export function ContextBudgetExhaustedBanner({ message, currentSpendUsd, capUsd }: Readonly<ContextBudgetExhaustedBannerProps>) {
  const badgeLabel = typeof currentSpendUsd === 'number' && typeof capUsd === 'number'
    ? `${formatUsd(currentSpendUsd)} / ${formatUsd(capUsd)}`
    : null

  return (
    <div className="py-2" role="alert" data-testid="context-budget-exhausted-banner">
      <div className="rounded-md border border-danger-foreground bg-danger px-4 py-3">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-4 w-4 shrink-0 text-danger-foreground mt-0.5" aria-hidden />
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap gap-2">
              <p className="text-sm font-semibold text-danger-foreground">Halted — Token exhausted</p>
              {badgeLabel && (
                <span className="inline-flex items-center gap-1 rounded-full border border-danger-foreground px-2 py-0.5 text-xs font-medium text-danger-foreground shrink-0">
                  <TokenBudgetIcon className="h-3 w-3" />
                  {badgeLabel}
                </span>
              )}
            </div>
            <p className="mt-1 text-sm text-foreground">{message}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
